/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateShippingModel
 */
export interface UpdateShippingModel {
    /**
     * 
     * @type {string}
     * @memberof UpdateShippingModel
     */
    shippingMethodId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateShippingModel
     */
    pickupPointId?: string;
}

/**
 * Check if a given object implements the UpdateShippingModel interface.
 */
export function instanceOfUpdateShippingModel(value: object): boolean {
    return true;
}

export function UpdateShippingModelFromJSON(json: any): UpdateShippingModel {
    return UpdateShippingModelFromJSONTyped(json, false);
}

export function UpdateShippingModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateShippingModel {
    if (json == null) {
        return json;
    }
    return {
        
        'shippingMethodId': json['shippingMethodId'] == null ? undefined : json['shippingMethodId'],
        'pickupPointId': json['pickupPointId'] == null ? undefined : json['pickupPointId'],
    };
}

export function UpdateShippingModelToJSON(value?: UpdateShippingModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'shippingMethodId': value['shippingMethodId'],
        'pickupPointId': value['pickupPointId'],
    };
}

